export var SchedulePayUtil;
(function (SchedulePayUtil) {
    function payTypeLabel(payType) {
        switch (payType ?? '') {
            case 'PAY_ADVANCE':
                return '事前クレジットカード支払';
            case 'PAY_ON_THE_DAY':
                return '当日支払';
            default:
                return '';
        }
    }
    SchedulePayUtil.payTypeLabel = payTypeLabel;
})(SchedulePayUtil || (SchedulePayUtil = {}));
